import { toast } from '@/store/toast'

/** Copy text and say so; falls back to a hidden textarea where the API is missing (plain http). */
export async function copy(text: string, what = 'Copied'): Promise<void> {
  try {
    if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(text)
    else {
      const area = document.createElement('textarea')
      area.value = text
      area.style.position = 'fixed'
      area.style.opacity = '0'
      document.body.appendChild(area)
      area.select()
      document.execCommand('copy')
      area.remove()
    }
    toast.success(what, text)
  } catch {
    toast.error('Could not copy', 'Select the text and copy it by hand.')
  }
}
